<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M12 1.5a1 1 0 01.908.58l2.772 6.007 6.462.923a1 1 0 01.491 1.764l-4.99 4.084 1.819 6.367a1 1 0 01-1.486 1.127L12 18.674l-5.976 3.678a1 1 0 01-1.485-1.127l1.819-6.367-4.991-4.084a1 1 0 01.492-1.764l6.461-.923 2.772-6.006A1 1 0 0112 1.5zm0 3.386L9.908 9.42l-.228.494-.539.077-4.745.678 3.737 3.058.51.416-.181.633L7.169 19.3l4.307-2.65.524-.323.524.322 4.307 2.65-1.292-4.523-.181-.633.509-.416 3.738-3.058-4.746-.678-.539-.077-.228-.494L12 4.886z"/></svg>